export class RefundSummary {
  public constructor(
    private readonly data: {
      originalPrice: number;
      refundedPrice: number;
      currentPrice: number;
    },
  ) {}

  public get originalPrice(): number {
    return this.data.originalPrice;
  }

  public get refundedPrice(): number {
    return this.data.refundedPrice;
  }

  public get currentPrice(): number {
    return this.data.currentPrice;
  }
}
